export const guestPaymentBankInfoConstants = {
    GUEST_PAYMENT_STORE_BANK_INFO_COLLECTED: 'GUEST_PAYMENT_STORE_BANK_INFO_COLLECTED',
    GUEST_PAYMENT_CLEAR_BANK_INFO: 'GUEST_PAYMENT_CLEAR_BANK_INFO'
}